document.addEventListener('DOMContentLoaded', () => {
	const form = document.getElementById('subscribe-form')
	const formIds = JSON.parse(window.formIds)
	form.addEventListener('submit', e => {
		e.preventDefault()
		const formStatus = form.querySelector('output[name="status"]')
		const submitButton = form.querySelector('button[type="submit"]')
		form.setAttribute('disabled', true)
		submitButton.innerText = 'Subscribing...'
		const formData = new FormData(form)
		// We have to manually make this plugin work the way it SHOULD already...
		// So here, we're getting our array of mailing lists from the form data...
		const mailingLists = formData.getAll('mailingList[]')
		// Then we delete them from the form data because the plugin will throw a breaking error if we don't...
		formData.delete('mailingList[]')

		const promises = mailingLists.map(list => {
			const freshFormData = new FormData()
			for (const pair of formData.entries()) {
				freshFormData.set(pair[0], pair[1])
			}
			// Now we re-add the mailing list to the form with the proper key and value the plugin expects...
			freshFormData.set('mailingList', list)
			return subscribeToForm(freshFormData)
		})
		Promise.allSettled(promises).then(results =>
			results.forEach(result => {
				if (result.status === 'fulfilled') {
					formStatus.innerText = 'Success! Thank you for subscribing.'
					submitButton.innerText = 'Subscribed'
					form.reset()
				} else {
					formStatus.innerText = result.reason
					form.removeAttribute('disabled')
					submitButton.innerText = 'Subscribe'
				}
			}),
		)
	})

	function subscribeToForm(formData) {
		return fetch('/actions/campaign/forms/subscribe', {
			method: 'POST',
			headers: {
				Accept: 'application/json',
			},
			body: formData,
		}).then(response => {
			if (response.ok) {
				return response.json()
			} else {
				throw 'There was an error processing your request. Please try again, or reach out to us for assistance.'
			}
		})
	}
})
